module.exports = __webpack_public_path__ + "img/logo_campus.1e5815e8.png";